export default __webpack_public_path__ + "static/media/wiscoLogo.506e304c.svg";